import { render, staticRenderFns } from "./MyCoupons.vue?vue&type=template&id=67dfe958&scoped=true&"
import script from "./MyCoupons.vue?vue&type=script&lang=js&"
export * from "./MyCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dfe958",
  null
  
)

export default component.exports